if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      this.hydrateZoomImages();
      super.show(opener);
      this.showActiveMedia();
    }

    // Zoom image URLs are parked in data-zoom-* (snippets/product-media.liquid) so the hidden modal
    // does not download them on page load. They stay loading="lazy", so only the images scrolled
    // to inside the modal are fetched.
    hydrateZoomImages() {
      this.querySelectorAll('img[data-zoom-src]').forEach((img) => {
        if (img.dataset.zoomSrcset) img.srcset = img.dataset.zoomSrcset;
        img.src = img.dataset.zoomSrc;
        delete img.dataset.zoomSrcset;
        delete img.dataset.zoomSrc;
      });
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
